module.exports = __webpack_public_path__ + "static/media/lv.1cf471ba.svg";